import { skipToken } from "@tanstack/react-query";
import { selectEnhacedElementMapping } from "@v1/reducers/core-reducer";
import { useEditorSelector } from "@v1/store/store";
import useCurrentProjectId from "@v2/hooks/useCurrentProjectId";
import { elementRouter } from "@v2/trpc/routes/element";

const useGetElementsMapping = () => {
  const projectId = useCurrentProjectId();
  const { data: archivedElements = [] } = elementRouter.listArchived.useQuery(
    projectId ? { projectId } : skipToken,
  );

  const { elementMapping } = useEditorSelector((state) => {
    return selectEnhacedElementMapping(state, archivedElements);
  });

  return elementMapping;
};

export default useGetElementsMapping;
